import { PersonType } from 'src/app/services/models/enums';
import type { TableConfig } from 'src/app/shared/components/generic-table/interfaces/table-config.interface';
import { CpfMaskPipe } from 'src/app/shared/pipes/cpf-mask.pipe';
import { CnpjMaskPipe } from 'src/app/shared/pipes/cnpj-mask.pipe';

const cpfMask = new CpfMaskPipe();
const cnpjMask = new CnpjMaskPipe();

export interface TrackingRegistryTableView {
  document: string;
  type: PersonType;
  name: string;
}

export const WALLET_DETAILS_TABLE_CONFIG: TableConfig<TrackingRegistryTableView> = {
  columns: [
    {
      id: 'document',
      title: $localize`:@@label_document:Documento`,
      width: '200px',
      getValue(item) {
        return item.type === PersonType.PERSON
          ? cpfMask.transform(item.document)
          : cnpjMask.transform(item.document);
      },
    },
    {
      id: 'type',
      title: $localize`:@@type:Tipo`,
      width: '150px',
    },
    {
      id: 'name',
      title: $localize`:@@js_name:Nome`,
      width: '2fr',
    },
  ],
  trackByProp: ['document'],
  rowIdFn: (row: TrackingRegistryTableView) => row.document
};
